import { Grid, Typography } from '@mui/material';
import { SelectElement } from 'react-hook-form-mui';
import { FormattedMessage, useIntl } from 'react-intl';
import { StreamMode } from '../../../types';

export function ScreenModeField() {
  const { $t } = useIntl();

  const optionModeDefault = {
    id: StreamMode.DEFAULT,
    name: $t({
      id: 'logger.streamScreen.modes.defaultMode',
      defaultMessage: 'Modo default',
    }),
  };
  const optionModeEditor = {
    id: StreamMode.EDITOR,
    name: $t({
      id: 'logger.streamScreen.modes.editorMode',
      defaultMessage: 'Modo editor',
    }),
  };

  return (
    <>
      <Grid item xs={12} md={6}>
        <Typography>
          <FormattedMessage
            id="logger.streamScreen.screenSettings.screenMode"
            defaultMessage="Modo de pantalla"
          />
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <SelectElement
          name="mode"
          label=""
          options={[
            {
              id: optionModeDefault.id,
              label: optionModeDefault.name,
            },
            {
              id: optionModeEditor.id,
              label: optionModeEditor.name,
            },
          ]}
          valueKey="id"
          labelKey="label"
          fullWidth
        />
      </Grid>
    </>
  );
}
